import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import estilos from './TabsInspeccionarComponent.module.css'
import TabsRecepcionMateriaPrimaComponent from './TabsRecepcionMateriaPrimaComponent'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import FotoGaleriaComponent from '../Forms/Fotogaleria/FotoGaleriaComponent'

function TabsanexoComponent(props) {


    const [tabUno, setTabUno] = React.useState(false)
    const [tabDos, setTabDos] = React.useState(false)
    const [tabTres, setTabTres] = React.useState(true)
    const [tabCuatro, setTabCuatro] = React.useState(false)

    const todo = props.detalles;
    const instalacion = props.instalacion;

    const setearValoresUno = () => {
        setTabUno(true); setTabDos(false); setTabTres(false); setTabCuatro(false);
        scrollUp();
    }
    const setearValoresDos = () => {
        setTabUno(false); setTabDos(true); setTabTres(false); setTabCuatro(false);
        scrollUp()
    }
    const setearValoresTres = () => {
        setTabUno(false); setTabDos(false); setTabTres(true); setTabCuatro(false);
    }
    const setearValoresCuatro = () => {
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(true);
    }

    React.useEffect(() => {
        todo
    }, [todo])

    function scrollUp() {
        var scroll = document.documentElement.scrollTop;
        if (scroll > 0) {
            window.requestAnimationFrame(scroll);
            window.scrollTo(0, scroll - (scroll / 10));
        }
    }


    return (
        <Fragment>
            <div className={`row text-center ${estilos.tabsCuartoNivel} `}>
                {/**OPCIONES NIVEL 3 */}

                <div className='col-6'>
                    <button onClick={() => setearValoresTres()} type="button" className={`btn btn-light ${estilos.block}`} style={{ background: tabTres ? '#68813B' : 'transparent', color: tabTres ? 'white' : 'black' }}>Recepción de materia prima</button>

                </div>
            </div>

            {
                tabUno ? (
                    <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                        <div className="col ">
                            <button type="button" className={`btn ${estilos.botonVerdeCOMERCAM}`} onClick={() => setearValoresDos()}><ArrowForwardIcon /></button>
                        </div>
                    </div>
                ) :
                    tabDos ? (
                        <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                            <div className="col ">
                                <button type="button" className={`btn ${estilos.botonVerdeCOMERCAM}`} onClick={() => setearValoresUno()}><ArrowBackIcon /></button>
                            </div>
                            <div className="col ">
                                <button type="button" className={`btn ${estilos.botonVerdeCOMERCAM}`} onClick={() => setearValoresTres()}><ArrowForwardIcon /></button>
                            </div>
                        </div>
                    ) :
                        tabTres ? (
                            <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                <TabsRecepcionMateriaPrimaComponent detalles={todo} instalacion={instalacion}></TabsRecepcionMateriaPrimaComponent>
                                <div className="col ">
                                    <button type="button" className={`btn ${estilos.botonVerdeCOMERCAM}`} onClick={() => setearValoresCuatro()}>Fotogaleria<ArrowForwardIcon /></button>
                                </div>
                            </div>
                        ) :
                            tabCuatro ? (
                                <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                    <div className="col ">

                                        <button type="button" className={`btn ${estilos.botonVerdeCOMERCAM}`} onClick={() => setearValoresTres()}><ArrowBackIcon />Recepción de materia prima</button>
                                    </div>
                                </div>
                            ) :
                                (<></>)
            }

        </Fragment>
    );
};


export default withRouter(TabsanexoComponent)
